import * as am5 from '@amcharts/amcharts5/'

export default defineNuxtPlugin(() => {
  am5.addLicense('AM5C313541768')
})
